import React, {Component} from 'react'
import styled from 'styled-components'
import DigitalCard from '../../../card/App'
import extend from 'smart-extend'
import equals from 'deep-eql'
FULL_WIDTH = 431
FULL_HEIGHT = 865

class DigitalPreview extends Component
	componentDidMount: ()->
		if not @card
			@storeLastUpdate()
	
	componentDidUpdate: (prevProps)->
		return if @props.currentScreen isnt 'confirmation'
		
		# if not equals(@props.data, @lastUpdate)
		# 	@storeLastUpdate()
		# 	@card.update(prepareData(@props.data))

	storeLastUpdate: ()->
		@lastUpdate = extend.clone.deep @props.data

	render: ()->
		data = prepareData(@props.data)
		
		<div>
			{if @props.label
				<Label>Digital Card</Label>
			else null}
			
			<MinifierWrapper scale={@props.scale}>
				<PhoneContainer scale={@props.scale}>
					<PhoneImage src="/files/img/iphone-x.png" />
					<PreviewContainer>
						<DigitalCard card={data} />
					</PreviewContainer>
				</PhoneContainer>
			</MinifierWrapper>
		</div>



export Label = styled.h4"""
	margin: 30px auto 16px;
	font-family: gotham;
	font-size: 14px;
	font-weight: 600;
	text-align: center;
	text-transform: uppercase;
"""


MinifierWrapper = styled.div"""
	width: #{({scale})-> "#{FULL_WIDTH * scale}px"};
	height: #{({scale})-> "#{FULL_HEIGHT * scale}px"};
	margin: 0 auto;
"""

PhoneContainer = styled.div"""
	position: relative;
	width: #{FULL_WIDTH}px;
	height: #{FULL_HEIGHT}px;
	transform: scale(#{({scale})-> scale});
	transform-origin: 0 0;
"""

PhoneImage = styled.img"""
	position: relative;
	z-index: 2;
	width: 100%;
	pointer-events: none;
"""

PreviewContainer = styled.div"""
	position: absolute;
	top: 22px;
	left: 25px;
	z-index: 1;
	overflow: scroll;
	width: 378px;
	height: 812px;
	background-color: white;
"""


prepareData = (data)->
	extend.deep({demo:true}, data)


export default DigitalPreview